import checkRole from '@/lib/checkRole';
import store from '@/store/index';
import Vue from 'vue';
import VueRouter from 'vue-router';
import initModules from './init-modules';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

initModules(router);

const DEFAULT_TITLE = 'OFFICE';

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else document.title = DEFAULT_TITLE;

  const { accessList, guest } = to.meta;

  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const roles = store.getters['auth/userRole'];

  // Для авторизованных пользователей
  if (isAuthenticated) {
    // Если маршрут имеет ограничения в виде accessList, перенаправлять на 403
    if (accessList && !checkRole(roles, accessList)) {
      return next('/403');
    }
    // Если маршрут имеет ограничения guest, перенаправлять на главную
    if (guest) {
      return next('/');
    }
    return next();
  }

  // Для неавторизованных пользователей
  if (accessList) {
    return next('/403');
  }

  return next();
});

export default router;
